import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import { Button, Box, Container, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'

import { PageTitle } from '@scoir/headers'

import SlateSetup from './SlateSetup'
import { SetupTile } from './SetupTile'

export class IntegrationsOverviewRoute extends React.Component {
  static propTypes = {
    scid: PropTypes.number.isRequired,
    features: PropTypes.object.isRequired,
  }
  static defaultProps = {
    features: {},
  }

  componentDidMount() {
    document.title = 'Scoir - Document Integration Setup'
  }

  render() {
    return (
      <Container maxWidth="md">
        <Box my={4}>
          <PageTitle
            titleProps={{ component: 'h1' }}
            title="Document Integration Setup"
          />

          <Box
            display="flex"
            flexDirection={{ xs: 'column', md: 'row' }}
            alignItems={{ xs: 'flex-start', md: 'center' }}
            justifyContent="center"
            mt={3}
          >
            {this.props.features.SlateSFTP && (
              <>
                <SetupTile>
                  <Typography
                    variant="h5"
                    component="h2"
                    gutterBottom
                  >
                    Easy Slate Setup
                  </Typography>
                  <Typography>
                    Add the Scoir Source Format and User in the Slate Template Library. Next, enter your user details
                    below.
                  </Typography>
                  <SlateSetup scid={this.props.scid} />
                </SetupTile>
                <Box m={2}>
                  <Typography
                    component="span"
                    variant="h5"
                  >
                    Or
                  </Typography>
                </Box>
              </>
            )}
            <SetupTile>
              <Typography
                variant="h5"
                component="h2"
                gutterBottom
              >
                Manual Setup
              </Typography>
              <Typography paragraph>Manual integration using SFTP.</Typography>
              <Typography paragraph>How would you like to receive documents?</Typography>

              <Button
                color="primary"
                variant="contained"
                component={Link}
                size="large"
                to={`${import.meta.env.BASE_URL}/documents/integrations/config/sftp`}
              >
                SFTP Setup
              </Button>
            </SetupTile>
          </Box>
        </Box>
      </Container>
    )
  }
}

export default connect((store) => ({
  scid: store.user.record.Scid,
  features: store.features.record,
}))(IntegrationsOverviewRoute)
